import React from 'react';

import type { Section } from '../../../../../models';
import { HEATING_OIL } from '../../../../../constants';
import UtilitiesOwnRentalPropertyAnnualCosts from '../../Utilities/UtilitiesEstimatedAnnualCost/UtilitiesOwnRentalPropertyAnnualCosts';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function HeatingOilOwnRentalPropertyAnnualCosts({ section, setSectionValues }: Props): JSX.Element {
  return (
    <UtilitiesOwnRentalPropertyAnnualCosts
      section={section}
      setSectionValues={setSectionValues}
      annualCostsField={HEATING_OIL.FIELD_NAME.ANNUAL_COSTS}
      utilityName="Heating oil"
      utilityOwnRentalPropertyYesField={HEATING_OIL.FIELD_NAME.OWN_PROPERTY_YES}
      utilityOwnRentalPropertyNoField={HEATING_OIL.FIELD_NAME.OWN_PROPERTY_NO}
      knowAnnualCostsSimilarRentalUnitField={HEATING_OIL.FIELD_NAME.KNOW_ANNUAL_COSTS_SIMILAR_RENTAL_UNIT}
    />
  );
}

export default HeatingOilOwnRentalPropertyAnnualCosts;
